exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".attachmentPreviewModal-f0001{width:100%;height:80vh}.noRenderer-b5ecd{width:100%;display:flex;align-items:center;justify-content:center}.noRenderer-b5ecd .ant-result-title{font-size:20px}", ""]);

// Exports
exports.locals = {
	"attachmentPreviewModal": "attachmentPreviewModal-f0001",
	"noRenderer": "noRenderer-b5ecd"
};